import React, { useState, useEffect, useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import { ScItemTypes } from "../ScItemTypes";

import { v4 as uuidv4 } from "uuid"; 
import { useEyeconxStore } from "../../../../store/eyeconxStore";

const ScElement = ({ id, index, moveElement, element }) => {
  const {moveDataItem,deleteSelectedQuestion,addChoiceToDataItem,updateDataItem} =useEyeconxStore()
  const ref = useRef(null);
  const mychoices = element.choices;
  const [myelement,setMyElement] = useState(element)
  const [isEditText, setIsEditText] = useState(false);
  const [text, setText] = useState("Question"); //add to dispactch
  //const [queType, setQueType] = useState(element.type);
  const queType = element.type;
  //const [radiogroupId, setRadiogroupId] = useState(uuidv4());
  const radiogroupId = uuidv4()
  const [choices, setChoices] = useState(mychoices); //add to dispactch
  //const choices = element.choices;
  const [isEditChoices, setIsEditChoices] = useState(false);
//Fix choices 
  //const dispatch = useDispatch();

  const handleAddOption = () => {
   
    const newChoices = [...choices];
    newChoices.push({
      id: uuidv4(),
      text: "Choice",
      value: "Value",
      radiogroup: radiogroupId,
    });
    const data = {
      index : index,
      choices:newChoices
    }
    //dispatch(addNewChoice(data))
    addChoiceToDataItem(data)
    setChoices(newChoices);
  };
  const handleRemoveOption = (id) => {
   
    const newChoices = [...choices];
    newChoices.splice(id, 1);
    const data = {
      index : index,
      choices:newChoices
    }
     //dispatch(addNewChoice(data))
     addChoiceToDataItem(data)
    setChoices(newChoices);
  };


  const handleValueTextChange = (e, chindex) => {
   
    const newChoices = choices.map(ch=>{
      if(ch.id===chindex){
        return {...ch,value:e}
      }
      return ch;
    })
    const data = {
        index:index,
        choices:newChoices
    }
   addChoiceToDataItem(data)
    setChoices(newChoices);
  };


  const handleTextTextChange = (e,chid) => {
   
   const newChoices = choices.map(ch =>{
      if(ch.id===chid){
        console.log("id="+chid)
        return {...ch,text:e};
      }
    
      return ch;
    })
    const data = {
      index : index,
      choices:newChoices
    }
    //dispatch(addNewChoice(data))
    addChoiceToDataItem(data)
    setChoices(newChoices);
  };


  const handleSelectChange = (e, evalue,chid) => {
  console.log(e)
  console.log(evalue)
  console.log(chid)
    const newChoices = choices.map(ch =>{
      if(ch.id===chid){
        return {...ch,isSelected:evalue};
      }
    
      return ch;
    })
    const data = {
      index : element.id,
      choices:newChoices
    }
    //dispatch(addNewChoice(data))
    addChoiceToDataItem(data)
    setChoices(newChoices);
    
  };
  const handleDeleteQuestion = (qid) => {
    //dispatch(deleteSelectedQuestion(qid))
    deleteSelectedQuestion(qid)
  }
  const handleTitleChange = (e)=>{
    setText(e.target.value)
    setMyElement({...myelement,title:e.target.value})
    const retVal ={
      id:myelement.id,
      vals:myelement
  }
    updateDataItem(retVal)
    //console.log("Title:"+e.target.value)
  }


  useEffect(()=>{
    //const retVal ={
      //  id:index,
      //  vals:myelement
   // }
    //console.log(retVal)
    //if(myelement.title.length>0){
     // setText(myelement.title)
    //}
   
   // dispatch(updateDataItem(retVal))
   //console.log("Update element: ")
  // console.log(myelement)
   //updateDataItem(retVal)
},[myelement])

  const [{ handlerId }, drop] = useDrop({
    accept: ScItemTypes.QUESTIONELEMENT,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      //console.log("movecard");
      //console.log("dragInder:" + dragIndex + " hoverInder:" + hoverIndex);
     //dispatch(moveDataItem({ dragIndex, hoverIndex }));
     moveDataItem(dragIndex,hoverIndex)
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ScItemTypes.QUESTIONELEMENT,
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
 // const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  return (
    <>
      <div
        ref={ref}
        data-handler-id={handlerId}
        id={id}
        className="col-md-12 p-4 m-3 rounded-3 questionarea"
      >
        <div className="form-group">
          {isEditText ? (
            <input
              type="text"
              className="form-control mb-2"
              onBlur={() => setIsEditText(!isEditText)}
              placeholder={text}
              onChange={(e) => handleTitleChange(e)}
            />
          ) : (
            <label
              className="form-label mb-3"
              onClick={() => setIsEditText(!isEditText)}
            >
              {" "}
              {index + 1}. {text}
            </label>
          )}

          {queType === "text" ? (
            <input
              type="text"
              disabled
              className="form-control form-control-sm"
            />
          ) : null}
          {queType === "comment" ? (
            <textarea className="form-control" row="3" disabled></textarea>
          ) : null}

          {queType === "radio" || queType === "checkbox" ? (
            <div className="p-1">
              {!isEditChoices
                ? choices.map((choice) => {
                  return (
                    <div
                      className="form-check"
                      key={choice.id}
                      onClick={() => setIsEditChoices(!isEditChoices)}
                    >
                      <input
                        type={queType}
                        value={choice.value}
                        name={radiogroupId}
                        className="form-check-input"
                        disabled
                        checked={choice.isSelected}
                      />
                      <label className="form-check-label">
                        {choice.text}
                      </label>
                    </div>
                  );
                })
                : choices.map((choice, index) => {
                  return (
                    <div className="input-group mt-2" key={index}>
                      <div className="input-group-text">
                        <input
                          type={queType}
                          name={radiogroupId}
                          className="form-check-input mt-0"
                          checked={choice.isSelected}
                          value={choice.value}
                          onChange={(e) =>
                            handleSelectChange(e, e.target.checked, choice.id)
                          }
                        />
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={choice.value}
                        onChange={(e) =>
                          handleValueTextChange(e.target.value, choice.id)
                        }
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder={choice.text}
                        onChange={(e) =>
                          handleTextTextChange(e.target.value,choice.id)
                        }
                      />
                      <div
                        className="input-group-text"
                        onClick={() => handleRemoveOption(index)}
                      >
                        <i className="bi bi-trash"></i>
                      </div>
                    </div>
                  );
                })}
              {isEditChoices ? (
                <div>
                  <button
                    className="btn btn-secondary btn-sm m-2"
                    onClick={handleAddOption}
                  >
                    <i className="bi bi-plus"></i>
                    Add Option
                  </button>
                  <button
                    className="btn btn-success btn-sm m-2"
                    onClick={() => setIsEditChoices(!isEditChoices)}
                  >
                    <i className="bi bi-check"></i>
                    Done
                  </button>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : null}
        </div>
        <div className="editquestion d-flex justify-content-between bg-secondary text-white rounded-3">
          

          <div className="btn btn-sm btn-secondary" onClick={() => handleDeleteQuestion(index)}>
            <i className="bi bi-trash"></i>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScElement;
